import { CanActivate, ExecutionContext, Injectable } from '@nestjs/common';
import { RequestCustom } from '@ip6m/server/shared';
import { UserDataService } from '@ip6m/server/data-access-user';
import { ADMIN_ROLE } from 'libs/server/config/src/lib/constants';

@Injectable()
export class IsAdminGuard implements CanActivate {

    constructor(private userDataService: UserDataService) {}

    async canActivate(context: ExecutionContext): Promise<boolean> {
        const request: RequestCustom = context.switchToHttp().getRequest();
        if(request.context.profileId) {
            const user = await this.userDataService.get(parseInt(request.context.profileId));
            
            let isAdmin = false;
            user.roles.forEach(role => {
                if(role.id == ADMIN_ROLE) {
                    isAdmin = true;
                }
            })
            return isAdmin;
        }
        else {
            return false;
        }
    }
}